import cn from "classnames"

import { preventEventBubbling } from "@/helpers/utils"

import styles from "./InformationPopover.module.scss"

import type { CommonTemplateInformationPopoverProps } from "./CommonTemplateInformationPopover.types"

export const CommonTemplateInformationPopover = ({
  title,
  children,
  footer,
  whiteSpace,
  classes = {}
}: CommonTemplateInformationPopoverProps) => {
  const childrenExists = children !== undefined && children !== null

  return (
    <div className={styles.commonTemplate} onClick={preventEventBubbling}>
      {title && (
        <>
          <div className={cn(styles.commonTemplateTitle, classes.title)}>
            {title}
          </div>
          {childrenExists && <div className={styles.hr} />}
        </>
      )}
      {childrenExists && (
        <div
          className={cn(
            styles.commonTemplateContent,
            { [styles.commonTemplatePre]: whiteSpace === "pre" },
            classes.content
          )}
        >
          {children}
        </div>
      )}
      {footer && (
        <div className={cn(styles.commonTemplateFooter, classes.footer)}>
          {footer}
        </div>
      )}
    </div>
  )
}
